import { MinzeElement, Attrs } from 'minze'

export interface LvcChevronDownIcon {
  width?: number
  height?: number
}

export class LvcChevronDownIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 24],
    ['height', 24],
  ]
  html = () => `
  <svg width="${this.width ?? '24'}" height="${this.height ?? '24'}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.5261 6.64957C20.9958 6.9401 21.141 7.55639 20.8504 8.02608C20.1756 9.11701 18.1089 11.5616 16.2177 13.6681C15.2578 14.7372 14.3157 15.7495 13.5774 16.4988C13.21 16.8715 12.882 17.1906 12.6223 17.4214C12.4946 17.5348 12.3658 17.6428 12.2469 17.728C12.1888 17.7697 12.1121 17.8211 12.025 17.8663L12.0232 17.8672C11.969 17.8953 11.7672 18 11.5 18C11.2148 18 11 17.8793 10.95 17.8513C10.9485 17.8504 10.9471 17.8496 10.9459 17.8489C10.8598 17.8009 10.783 17.7463 10.7243 17.7019C10.6038 17.6107 10.4697 17.4938 10.3339 17.3689C10.0578 17.1151 9.70425 16.763 9.30606 16.353C8.50633 15.5295 7.48253 14.4268 6.45035 13.3007C5.60045 12.3736 4.7512 11.4378 4.01027 10.6214C2.92856 9.42948 2.07774 8.49197 1.79289 8.20712C1.40237 7.8166 1.40237 7.18343 1.79289 6.79291C2.18342 6.40239 2.81658 6.40239 3.20711 6.79291C3.52361 7.10941 4.44877 8.12862 5.58309 9.37824C6.31253 10.1818 7.12846 11.0807 7.92465 11.9493C8.95497 13.0733 9.96242 14.1581 10.7408 14.9596C11.0401 15.2678 11.2991 15.5274 11.509 15.7287C11.6888 15.5593 11.9053 15.3462 12.1528 15.095C12.8618 14.3755 13.7815 13.3878 14.7295 12.332C16.6539 10.1885 18.5872 7.88302 19.1496 6.97396C19.4401 6.50427 20.0564 6.35903 20.5261 6.64957Z" fill="#1E007D"/>
</svg>

  `

  css = () => `
    :host {
      width: ${this.width ?? '24'}px;
      height: ${this.height ?? '24'}px;
    }
    
  `
}
